import { memo } from 'react';

import { Filters } from '@air/next-icons';
import { Button } from '@air/primitive-button';

import { type FiltersPopoverTriggerProps } from '~/components/Filters/FiltersButton/FiltersDropdownTrigger';
import { useAppliedFiltersCount } from '~/hooks/filters/useAppliedFiltersCount';

export type MobileSearchActiveFilterButtonProps = Pick<FiltersPopoverTriggerProps, 'onClick'>;

export const MobileSearchActiveFilterButton = memo(({ onClick }: MobileSearchActiveFilterButtonProps) => {
  const { filtersCount } = useAppliedFiltersCount();

  return (
    <Button
      appearance="outline"
      className="px-2"
      data-testid="NEW_FILTERS_BUTTON"
      color="grey"
      onClick={onClick}
      size="large"
    >
      <Filters className="size-6" />
      {!!filtersCount && (
        <div
          className="absolute -top-1 -right-1 flex h-4 min-w-[16px] items-center justify-center rounded-24 bg-blue-2 px-1 font-bold text-10 text-blue-9 uppercase"
          data-testid="NEW_FILTERS_BUTTON_COUNT"
        >
          {filtersCount}
        </div>
      )}
    </Button>
  );
});

MobileSearchActiveFilterButton.displayName = 'MobileSearchActiveFilterButton';
